import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';

export function RouteFallback() {
  return (
    <Stack sx={{ gap: 2 }} aria-busy="true" aria-label="Loading page">
      <Skeleton variant="text" width={280} height={44} />
      <Skeleton variant="text" width="50%" sx={{ mb: 2 }} />
      <Skeleton variant="rounded" height={64} />
      <Skeleton variant="rounded" height={360} />
    </Stack>
  );
}
